import { UserTicketDanceRoleTypeEnum } from '../enums';

export class CreateTicketOrderItemDto {
  ticketId?: string;
  quantity?: number;
  ticketDanceRole?: UserTicketDanceRoleTypeEnum;
}
